export const config = {
  apiBaseUrl: process.env.REACT_APP_IKT_ADMIN_API_BASE_URL || 'http://localhost:8000/',
  periodicFetchInterval: 5000
};

export const toastDuration = 2000;
export const toastDurationLong = 10000;
